jQuery(window).on("load",function(e){
	var menuitemhaschildren = document.querySelectorAll("header#site-header nav ul.menu > li.menu-item-has-children > a");
	for (var i = 0; i < menuitemhaschildren.length; i++) {
		menuitemhaschildren[i].classList.add('collapsed');
		menuitemhaschildren[i].classList.add('collapsable-link');
		menuitemhaschildren[i].setAttribute('data-bs-toggle','collapse');
		menuitemhaschildren[i].setAttribute('role','button');
		menuitemhaschildren[i].setAttribute('aria-expanded','false');
		var menuitemid = menuitemhaschildren[i].parentElement.id;
		menuitemhaschildren[i].setAttribute('href','#collapse-'+menuitemid);
		menuitemhaschildren[i].setAttribute('aria-controls','collapse-'+menuitemid);
		var submenu = menuitemhaschildren[i].parentElement.querySelectorAll('.sub-menu')[0];
		submenu.setAttribute('id','collapse-'+menuitemid);
		submenu.classList.add('collapse');
}
	jQuery("header#site-header nav ul.menu > li.menu-item-has-children > a").click(function (e) {
		e.preventDefault();
		if (this.classList.contains('collapsed')) {
			this.setAttribute('aria-expanded','false');
		}
		else {
			this.setAttribute('aria-expanded','true');
		}
	});
});
jQuery(document).ready(function () {
	"use strict";
	jQuery("#nav-overlay").click(function (e) {
			document.body.classList.toggle("menu-open");
		});
});
